import PaymentMethodPopup from "./PaymentMethodPopup";
export default PaymentMethodPopup;
